import type * as braintree from 'braintree-web'

import { actionTypes } from 'actions/actionTypes'
import type { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const savePayPalExpressCheckoutDeliveryAddress: CheckoutActionCreator = ({
  line1,
  line2,
  city,
  state,
  postalCode,
}: braintree.PayPalTokenizePayload['details']['shippingAddress']) => ({
  type: actionTypes.SAVE_PAYPAL_EXPRESS_CHECKOUT_DELIVERY_ADDRESS,
  deliveryAddress: {
    name: 'My Address',
    line1,
    line2,
    town: city,
    county: state,
    postcode: postalCode,
  },
})
